export default "__VITE_ASSET__pa7SkYmA__"